
import { isgz } from '@/api/user'
import imgscroll from '@/assets/jifenhuangou/lottery/point.png'
import openbg from '@/assets/jifenhuangou/lottery/popup-bg.png'
import { getRequest } from '@/libs/utils.js'
import { award, isAward, getExam, isAwardbefore } from '@/api/lottery'
import { getAddressDefault } from '@/api/user'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XInput from 'vux/src/components/x-input/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'

import { addCreditParty, addAddress2, relation, view, addPartyCount } from '@/api/jfhl.js'
import { updateuser } from '@/api/lottery.js'
export default {
directives: {
TransferDom
},
components: {
XDialog,
XInput,
XButton,
Group
},
data () {
return {
imgscroll: imgscroll,
showisgz: false,
show: false,
obj: {
linkman: '',
phone: '',
randnum: '',
address: ''
},
click: false,
dataList: [
{
index: 8,
img: require('../../assets/answer/pic_501.png'),
imghover: require('../../assets/answer/pic_502.png')
},
{
index: 1,
img: require('../../assets/answer/pic_chumanyi1.png'),
imghover: require('../../assets/answer/pic_chumanyi2.png')
},
{
index: 2,
img: require('../../assets/answer/pic_yashua1.png'),
imghover: require('../../assets/answer/pic_yashua2.png')
},
{
index: 7,
img: require('../../assets/answer/pic_xishouye1.png'),
imghover: require('../../assets/answer/pic_xishouye2.png')
},
{
index: '',
img: require('../../assets/jifenhuangou/lottery/btnn.png'),
imgstart: require('../../assets/jifenhuangou/lottery/btnn-start.png'),
imgend: require('../../assets/jifenhuangou/lottery/btnn-end.png'),
imgZj: require('../../assets/jifenhuangou/lottery/btnn2.png')
},
{
index: 3,
img: require('../../assets/answer/pic_xifashui1.png'),
imghover: require('../../assets/answer/pic_xifashui2.png')
},
{
index: 6,
img: require('../../assets/answer/pic_xiyiningzhu1.png'),
imghover: require('../../assets/answer/pic_xiyiningzhu2.png')
},
{
index: 5,
img: require('../../assets/answer/pic_dianfanbao1.png'),
imghover: require('../../assets/answer/pic_dianfanbao2.png')
},
{
index: 4,
img: require('../../assets/answer/pic_jinghuaru1.png'),
imghover: require('../../assets/answer/pic_jinghuaru2.png')
}
],
lottery: {
index: 0, // 当前转动到哪个位置，起点位置
count: 8, // 总共有多少个位置
timer: 0, // setTimeout的ID，用clearTimeout清除
speed: 100, // 初始转动速度
times: 0, // 转动次数
cycle: 100, // 转动基本次数：即至少需要转动多少次再进入抽奖环节
prize: 0 
},
times: '', // 答题次数
lotid: 0,
partyid: this.$route.params.partyid,
showOpen: false,
openbg: openbg,
personObj: {
NAME: '',
ADDRESS: '',
MOBILE: ''
},
prize: '',
activityType: 1,
addressDefault: false
}
},
created () {
this.getview()
},
computed: {
accountid () {
return this.$store.state.user.accountid
},
userid () {
return this.$store.state.user.userid
}
},
methods: {

isCurrentTime (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
return false
}
if (currentTime >= endTime) {
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '抽奖活动已结束'
})
return false
}
this.isawardNow()
this.getAddress()


},

isCurrentTime2 (beginTime, endTime) {
var currentTime = new Date()
var beginTime = new Date(beginTime)
var endTime = new Date(endTime)
if (currentTime < beginTime) {
this.click = true
this.activityType = 2
this.$vux.alert.show({
content: '抽奖活动还未开始'
})
return false
}
if (currentTime >= endTime) {
this.click = true
this.activityType = 3
this.$vux.alert.show({
content: '抽奖活动已结束'
})
return false
}
},

isawardNow () {
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.isaward === 1 && data.obj.iszhongjiang === 1) {
this.activityType = 4
this.prize = data.obj.item
if (data.obj.item.indexOf('积分') == -1) {
this.isAddress()
}
} else {

this.showOpen = false
}
})
},
gorule () {
this.$router.push({ name: 'answerRule', params: { partyid: this.partyid } })
},

beforeAward () {
isAwardbefore({
lotid: this.lotid,
openid: this.userid
}).then(res => {
if (res.obj.iszhongjiang === 1) {
if (res.obj.item.indexOf('积分') == -1) {
this.prize = res.obj.item
if (res.obj.partyuserid == '' && this.prize.indexOf('积分') == -1) {
this.showOpen = true
this.addressDefault = false
} else {
this.addressDefault = true
this.isAward()
}

}
this.isCurrentTime2('2019/11/09', '2019/11/11')
} else {
this.isCurrentTime('2019/11/09', '2019/11/11')
}
})
},

isAddress () {
updateuser({
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(res => {
if (res.obj.isaddress === 2) {
this.showOpen = true
this.addressDefault = false
} else {
this.showOpen = false
this.addressDefault = true
this.isAward()
}
})
},

addcount () {
addPartyCount({
partyid: this.partyid,
accoutid: this.accountid,
credittype: 1
}).then(res => {
})
},
onblur (val, $event) {
window.scroll(0, 0)
document.activeElement.scrollIntoViewIfNeeded(true)
},
getview () {
view({
id: this.partyid
}).then(res => {
this.lotid = res.obj.lotid
this.beforeAward()
})
},

isAward () {
let _this = this
isAward({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.obj.isaward === 1 && data.obj.iszhongjiang === 1) {
this.activityType = 4
this.prize = data.obj.item
if (data.obj.item.indexOf('积分') === -1) {
if (this.addressDefault) {
this.showOpen = true
}
} else {
this.$vux.alert.show({
content: '您已中奖，不能再抽奖了哦'
})
}
}
})
},

go () {
if (!this.click) {
this.getLottery()
}
},

getAddress () {
getAddressDefault({
accountid: this.accountid,
userid: this.userid
}).then(res => {
if (res.returnValue !== '') {
this.personObj = res.returnValue
this.personObj.ADDRESS = res.returnValue.PROVINCEIDNAME + res.returnValue.CITYIDNAME + res.returnValue.COUNTYIDNAME + res.returnValue.ADDRESS
}
})
},

sumbit () {
if (this.personObj.NAME === '') {
this.$vux.toast.text('请填写姓名！')
return false
}
if (this.personObj.ADDRESS === '') {
this.$vux.toast.text('请填写收货地址！')
return false
}
if (this.personObj.MOBILE === '') {
this.$vux.toast.text('请填写手机号码！')
return false
}
if (!/^\d{11}$/.test(this.personObj.MOBILE)) {
this.$vux.toast.text('手机号码格式不对哦～', 'middle')
return false
}
addAddress2({
userid: this.accountid,
partyid: this.partyid,
linkman: this.personObj.NAME,
phone: this.personObj.MOBILE,
address: this.personObj.ADDRESS
}).then(res => {
this.showOpen = false
if (res.success) {

relation({
partyuserid: res.obj.partyuserid,
lotid: this.lotid,
userid: this.accountid,
openid: this.userid
}).then(data => {
if (data.success) {
this.$vux.toast.text('您的信息提交成功！')
}
})
}
}).catch(() => {
this.showOpen = false
})
},
getLottery () {

award({
lotid: this.lotid,
openid: this.userid
}).then(data => {
if (data.success) {
if (data.obj.isaward === 2) {
this.$vux.toast.text('您已经抽过奖')
} else {
this.roll(parseInt(data.obj.angle), data.obj.item)
this.click = true
return false
}
} else {
let _this = this
this.$vux.confirm.show({
content: data.msg,
showCancelButton: false,
onConfirm () {
}
})
}
})
},
lotteryroll () {
var index = this.lottery.index
var count = this.lottery.count
index += 1
if (index > count) {
index = 1
}
this.lottery.index = index
return false
},
addIntegral (credit) {
addCreditParty({
accoutid: this.accountid,
credit: credit,
partyid: this.partyid,
type: 1
}).then(res => {
})
},
roll (prize, item) {
let _this = this
this.lottery.times += 1
this.lotteryroll() 
if (
this.lottery.times > this.lottery.cycle + 10 &&
this.lottery.prize === this.lottery.index
) {
clearTimeout(this.lottery.timer)
this.lottery.prize = 0
this.lottery.times = 0
if (item.indexOf('积分') != -1) {
this.$vux.alert.show({
content: '恭喜您抽中：' + item,
onHide () {
_this.addIntegral(item.replace(/[^0-9]/ig, ''))
_this.activityType = 4
_this.click = false
}
})
} else {
this.prize = item
setTimeout(() => {
this.activityType = 4
this.click = false
console.log(this.addressDefault)



this.showOpen = true

}, 1000)
}
} else {
if (this.lottery.times < this.lottery.cycle) {
this.lottery.speed -= 10
} else if (this.lottery.times === this.lottery.cycle) {
this.lottery.prize = prize
} else {
if (
this.lottery.times > this.lottery.cycle + 10 &&
((this.lottery.prize === 8 && this.lottery.index === 7) ||
this.lottery.prize === this.lottery.index + 1)
) {
this.lottery.speed += 110
} else {
this.lottery.speed += 20
}
}
if (this.lottery.speed < 40) {
this.lottery.speed = 40
}
this.lottery.timer = setTimeout(() => {
this.roll(prize, item)
}, this.lottery.speed) // 循环调用
}
return false
}
}
}
